// This file is generated by a script and should not be modified directly.
const markdown: string =
  "- `null` lorsque le champs `identifiant.rncp` est `null`.\n- Pour distinguer les fiches remplacées des fiches remplaçant, il faut se référer aux dates d'activation et de fin d'enregistrement des fiches.\n"
export default markdown
